import React from "react";
import { SpeedUpButton as SpeedUpButtonStyled } from "./styled";
import { useDispatch, useSelector } from "react-redux";
import { cyclePlaybackRate } from "../../redux/Slice/playerSlice";

export function SpeedUpButton() {
  const dispatch = useDispatch();
  const playbackRate = useSelector((state) => state.player.playbackRate);

  const handleClick = () => {
    dispatch(cyclePlaybackRate());
  };

  return (
    <SpeedUpButtonStyled onClick={handleClick}>
      {playbackRate}x
    </SpeedUpButtonStyled>
  );
}
